(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ra-data-hasura", [], factory);
	else if(typeof exports === 'object')
		exports["ra-data-hasura"] = factory();
	else
		root["ra-data-hasura"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 